import React, { useEffect, useRef, useState } from "react";
import "../../../assets/css/DiwaliLoader.css";
import $ from "jquery";

function DiwaliLoader() {
  const canvasRef = useRef(null);
  const [text, setText] = useState("");

  /* ================= TEXT LOGIC ================= */
  useEffect(() => {
    const messages = [
      "Happy Diwali 🪔",
      "Festival of Lights ✨",
      "Shubh Deepavali 🪔",
      "May Light Win Over Darkness",
      "Celebrate with Joy & Light",
    ];

    const msg = messages[Math.floor(Math.random() * messages.length)];
    let i = 0;

    $("body").css("overflow", "hidden");

    const typing = setInterval(() => {
      if (i < msg.length) {
        setText((p) => p + msg[i]);
        i++;
      } else {
        clearInterval(typing);
      }
    }, 90);

    setTimeout(() => {
      $("#diwali-loading").fadeOut(900);
      $("body").css("overflowY", "visible");
      $("#root").fadeIn();
    }, 6000);

    return () => clearInterval(typing);
  }, []);

  /* ================= CANVAS FIREWORK ================= */
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    let rockets = [];
    let particles = [];

    const colors = [
      "#ff3838",
      "#ffd700",
      "#00ffcc",
      "#4da6ff",
      "#ff66cc",
      "#ffffff",
    ];

    class Rocket {
      constructor() {
        this.x = Math.random() * canvas.width;
        this.y = canvas.height + 20;
        this.vy = Math.random() * 3 + 7;
        this.targetY = Math.random() * canvas.height * 0.4 + 100;
        this.color = colors[Math.floor(Math.random() * colors.length)];
        this.exploded = false;
      }

      update() {
        this.y -= this.vy;

        // 🔥 blast point
        if (this.y <= this.targetY && !this.exploded) {
          this.exploded = true;
          explode(this.x, this.y);
        }
      }

      draw() {
        ctx.fillStyle = this.color;
        ctx.fillRect(this.x, this.y, 3, 14);
      }
    }

    class Particle {
      constructor(x, y, color) {
        this.x = x;
        this.y = y;
        this.color = color;
        this.radius = Math.random() * 2 + 1;
        this.angle = Math.random() * Math.PI * 2;
        this.speed = Math.random() * 7 + 3;
        this.gravity = 0.05;
        this.life = 90;
      }

      update() {
        this.speed *= 0.98;
        this.x += Math.cos(this.angle) * this.speed;
        this.y += Math.sin(this.angle) * this.speed + this.gravity;
        this.life--;
      }

      draw() {
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
        ctx.fillStyle = this.color;
        ctx.fill();
      }
    }

    function explode(x, y) {
      for (let i = 0; i < 80; i++) {
        const c = colors[Math.floor(Math.random() * colors.length)];
        particles.push(new Particle(x, y, c));
      }
    }

    function animate() {
      ctx.fillStyle = "rgba(5, 0, 15, 0.25)";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      if (Math.random() < 0.045) rockets.push(new Rocket());

      rockets.forEach((r, i) => {
        r.update();
        r.draw();
        if (r.exploded) rockets.splice(i, 1);
      });

      particles.forEach((p, i) => {
        p.update();
        p.draw();
        if (p.life <= 0) particles.splice(i, 1);
      });

      requestAnimationFrame(animate);
    }

    animate();
  }, []);

  return (
    <div id="diwali-loading" className="diwali-loader">
      <canvas ref={canvasRef} className="firework-canvas"></canvas>

      {/* 🪔 DIYA */}
      <div className="diya">
        <div className="flame"></div>
      </div>

      <h1 className="diwali-text">{text}</h1>
      <p className="diwali-tagline">Festival of Lights</p>
    </div>
  );
}

export default DiwaliLoader;
